import React, { useEffect, useRef, useState } from "react";
import Header from "../../../components/global/Header";
import LeftNavbar from "../../../components/global/LeftNavbar";
import {  useTranslation } from 'react-i18next';
import { deleteAxiosResponse, getAxiosResponse,postAxiosResponse, putAxiosResponse } from '../../../services/authApiRoutes/APImethods';
import APIUrls from '../../../services/APIUrls';
import Select from 'react-select';
import Constants from "../../../Constants";
import { RotatingLines } from "react-loader-spinner";
import { useNavigate } from 'react-router-dom';
import $, { data } from "jquery";
import { confirmAlert } from "react-confirm-alert";
import { Breadcrumb } from "../../../components/dashboard/Breadcrumb";
import { handleError } from "../../../services/authApiRoutes/APImethods";

export default function ProjectSettingLanguageCustomCodeMapping() {
    const scrollRef = useRef(null);
    const backRef = useRef();
    
    const { t } = useTranslation();
    const translate = t;
    const [languageForCodeMapping,setLanguageForCodeMaping]=useState([])
    const [languageForCodeMappingCount,setLanguageForCodeMapingCount]=useState([])
    const[globalOverlay,showGlobalOverlay] = useState(true);
    const [errorCodeMsg,setErrorCodeMsg]=useState({code:"",msg:""}); 
    let [languageForMapping,setLanguageForMapping]=useState([]) 
    let [languageMapping,setLanguageMapping]=useState({language:"",customCode:""})
  	const navigate = useNavigate();
    const [customCodeLanguage,setCustomCodeLanguage]=useState("")
    const [filterLanguageForCodeMaping,setFilterLanguageForCodeMaping]=useState("")

    const sortedLanguageForCodeMapping = [...languageForCodeMapping].sort((a, b) => a.label.localeCompare(b.label));

    useEffect(()=>{
     getAllLanguageForMaping();
     getAllLanguageCodeMapping()
    },[])

    useEffect(()=>{
      $(".lastdisable").trigger("focus");
    }, [])

    const showModel = (index) => {
      $(document.activeElement).addClass('focusAdd');
      setconintendent(true);
      setLanguageMapping(languageForMapping[index])
      document.body.classList.add("modal-open");
      setTimeout(() => {
        $(".first-focus").trigger("focus");
        $("#ccwCancel").on("keydown", function (e) {
          if($('#ccwSaveBtn').prop('disabled') && e.key === Constants.TAB && !e.shiftKey) {
            e.preventDefault()
            $(".first-focus").trigger("focus");
          }
        });
        $("#ccwSaveBtn").on("keydown", function (e) {
          if(e.key === Constants.TAB && !e.shiftKey) {
            e.preventDefault()
            $(".first-focus").trigger("focus");
          }
        });
        if ($(".editLanguages").length) {
          $(".editLanguages").on("keydown", function (e) {
            if (e.key === Constants.ESCAPE) {
              hideModel();
              $('.focusAdd').trigger('focus');
              $('.inline-flex').removeClass('focusAdd');
            }
          });
        }
        $(".editModalClose").on("keydown", function (e) {
          if (e.key === Constants.TAB && e.shiftKey) {
            if ($('#ccwSaveBtn').prop('disabled')) {
              e.preventDefault();
              $("#ccwCancel").trigger("focus");
            } else {
              e.preventDefault();
              $("#ccwSaveBtn").trigger("focus");
            }
          }
        });
      }, 500);
    };

    const hideModel = () => {
      document.body.classList.remove("modal-open");
      setLanguageMapping({language:"",customCode:""})
    };
    const hideModalonKeydown = (e) => {
      if (e.key === Constants.ESCAPE) {
        hideModel();
      }
    }
   
    const showIntendentModel = () => {
      $(document.activeElement).addClass('focusAdd');
      setconintendent(false);
      document.body.classList.add("modal-open");
      setTimeout(() => {
        $(".first-focus").trigger("focus");
        $("#ccw").on("keydown", function (e) {
          if($('#ccwSave').prop('disabled') && e.key === Constants.TAB && !e.shiftKey) {
            e.preventDefault();
            $(".first-focus").trigger("focus");
          }
        });
        $("#ccwSave").on("keydown", function (e) {
          if(e.key === Constants.TAB && !e.shiftKey) {
            e.preventDefault();
            $(".first-focus").trigger("focus");
          }
        });
        if ($(".addModal").length) {
          $(".addModal").on("keydown", function (e) {
            if (e.key === Constants.ESCAPE) {
              hideModel();
              $('.focusAdd').trigger('focus');
              $('.focusAdd').removeClass('focusAdd');
            }
          });
        }
        $(".addModalClose").on("keydown", function (e) {
          if (e.key === Constants.TAB && e.shiftKey) {
            if ($('#ccwSave').prop('disabled')) {
              e.preventDefault();
              $("#ccw").trigger("focus");
            } else {
              e.preventDefault();
              $("#ccwSave").trigger("focus");
            }
          }
        });
      }, 500);
    };

    const hideIntendentModel = () => {
      document.body.classList.remove("modal-open");
      setCustomCodeLanguage("")
      setLanguageMapping({language:"",customCode:""})
      if($('.focusAdd').length){
        $('.focusAdd').trigger('focus');
        $('.focusAdd').removeClass('focusAdd');
      }
   };

   const hideIntendentModelonKeydown = (e) => {
    if (e.key === Constants.ENTER) {
      hideModel();
    }
   }

   const [conintendent, setconintendent] = useState(false);

    useEffect(()=>{
       getRemoveDuplicateData()
    },[languageForCodeMappingCount])

    const getRemoveDuplicateData=()=>{
      let result=languageForCodeMapping.filter(y=> !languageForMapping.some(x=> y.value===x?.language?.display))
      setLanguageForCodeMaping(result)
    }

    const getAllLanguageCodeMapping=async ()=>{
    await getAxiosResponse(APIUrls.LANGUAGE_FOR_CODE_MAPPING).then(res=>{
      if(res?.data?.status==="success"){
        const language= res?.data?.data?.map(language=>{
                return{
                  label:language?.display,
                  value:language?.display,
                  data:language
                }
        })
        setLanguageForCodeMaping(language)
        setLanguageForCodeMapingCount(language)
      }
      
    })
    }

    const getAllLanguageForMaping= async ()=>{
    await getAxiosResponse(APIUrls.LANGUAGES_FOR_MAPPING).then(res=>{
       if(res?.data?.status==="success"){
        setLanguageForMapping(res?.data?.data)
        showGlobalOverlay(false)
        $('.lastdisable').trigger('focus');
       }
       
    })
    }
    
    const setCustomLanguageTag=(event)=>{
      setCustomCodeLanguage(event)
      let obj={language:event?.data,customCode:""}
      setLanguageMapping(obj)
        let result=languageForCodeMapping.filter(data=> data?.value !==event?.value).map(data=>{
          return{
            label:data?.label,
            value:data?.value,
            data:data.data
          }
        })
        setFilterLanguageForCodeMaping(result)
    }
    
    const removeDataLaguageCodeMaping=(languageMapping)=>{
      // let result=languageForMapping.filter(data=> data?.language?.display !==language)
       let resultData=languageForMapping.filter(data=> data?.language?.display ===languageMapping?.language?.display)
       if(resultData && resultData.length>0){
        let obj={label:resultData[0].language.name,value:resultData[0].language.name,data:resultData[0].language}
        setLanguageForCodeMaping([...languageForCodeMapping,obj])
       }

      //confirmDelete(result,language)
      confirmDelete(languageMapping)
    }


    const confirmDelete = (data) => {
      $(document.activeElement).addClass('focusAdd');
      setTimeout(() => {
        $("#deleteNo").trigger("focus");
        $("#react-confirm-alert").attr( { role:"dialog", 'aria-modal':"true", 'aria-label':"Confirm Delete Language Custom Code Mapping"} );
      }, 500);
      confirmAlert({
        title: "Confirm Delete Language Custom Code Mapping",
        message: <p>Delete Language Custom Code Mapping: {data?.language?.display}</p>,
        buttons: [
          {
            label: "Yes",
            id: "deleteYes",
            onClick: () =>
            putAxiosResponse(APIUrls.LANGUAGES_FOR_MAPPING_DELETE,{
            
                customCode:data?.customCode,
                language:data?.language?.name
              
              })
                .then((res) => {
                 getAllLanguageForMaping()
                })
                .catch((err) => {
                  handleError(err);
                }),
            onKeyDown: (e) => {
              if (e.key === "Tab") {
                if (e.shiftKey === true) {
                  e.preventDefault();
                  $("#deleteNo").trigger("focus");
                }
              }
              if (e.key === Constants.ESCAPE) {
                $('.focusAdd').trigger('focus');
                $('.inline-flex').removeClass('focusAdd');
              }
            },
          },
          {
            label: "No",
            id: "deleteNo",
            onClick: () => {
              $('.focusAdd').trigger('focus');
              $('.inline-flex').removeClass('focusAdd');
            },
            onKeyDown: (e) => {
              if (e.key === "Tab") {
                if (e.shiftKey === false) {
                  e.preventDefault();
                  $("#deleteYes").trigger("focus");
                }
              }
              if (e.key === Constants.ESCAPE) {
                $('.focusAdd').trigger('focus');
                $('.inline-flex').removeClass('focusAdd');
              }
            },
          },
        ],
        closeOnEscape: true,
        closeOnClickOutside: true,
        overlayClassName: "delete_overlay",
      });
    };

    const customValidationLength=()=>{
        if((languageMapping?.language ==="" || (languageMapping?.customCode ==="" || languageMapping?.customCode.length > 7 )) ){
            return true;
        }
    return false
    }
    const createCustomCode=(event,label)=>{
      event.preventDefault()
    let obj={
      customCode:languageMapping?.customCode,
      language:languageMapping?.language?.name

    }
      if(label==='add'){
        postAxiosResponse(APIUrls.LANGUAGES_FOR_MAPPING_INDIVIDUAL,obj).then((res) => {
          if (res.status === 200) {
            getAllLanguageForMaping()
            showGlobalOverlay(false)
            if(res?.data?.data ===null) return 
             if(res?.data?.data?.errors !== undefined && Object.keys(res?.data?.data?.errors)?.length > 0){
              setErrorCodeMsg(res?.data?.data?.errors)
            }else{
              if(label==="add"){
              setLanguageForCodeMaping(filterLanguageForCodeMaping)
              }
            hideIntendentModel()
            setCustomCodeLanguage("")
              hideModel()
            }
  
          }
        }
        )
      }
      else{
        putAxiosResponse(APIUrls.LANGUAGES_FOR_MAPPING_INDIVIDUAL,obj).then((res) => {
          if (res.status === 200) {
            getAllLanguageForMaping()
            showGlobalOverlay(false)
            if(res?.data?.data ===null) return 
             if(Object?.keys(res?.data?.data?.errors)?.length > 0){
              setErrorCodeMsg(res?.data?.data?.errors)
            }else{
              
            hideIntendentModel()
            setCustomCodeLanguage("")
              hideModel()
            }
  
          }
        }
        )
      }
      
      
    }

    useEffect(()=>{
      setErrorCodeMsg({code:"",msg:""})
    },[languageMapping])

    const cancel=()=>{
      navigate("/dashboard")
    }
 
    const redirect=()=>{
      navigate("/settings")
    }
    $(".cw__input").onKeyDown = (e) =>{
      if (e.key === "Enter") e.preventDefault();
    };
    const crumbs = [
      {label:'Settings', url:'settings'},
      {label:'Language custom code mapping', url:''},
    ];
  return (
    <div className="body bg-color">
        <form onSubmit={event=>createCustomCode(event,"form")}>
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef}>
          <div id="content" className="dashboard-wrap">
             <Breadcrumb crumbs={ crumbs } />
             <div className="project-setting-page">
                <div className="project-heading userprofile-heading">
                    <div className="back-arrow flex-center">
                    <button aria-label="back" type="button" onClick={()=>navigate("/settings")} ref={backRef}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none">
                        <path d="M0.46967 5.96967C0.176777 6.26256 0.176777 6.73744 0.46967 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96447 6.59619 1.48959 6.3033 1.1967C6.01041 0.903806 5.53553 0.903806 5.24264 1.1967L0.46967 5.96967ZM1 7.25H14V5.75H1V7.25Z" fill="#1D4ED8"/>
                        </svg>
                    </button>
                    <span>Back to Settings</span>
                    </div>
                    <h3 className="flex">Language Custom Code Mapping</h3>
                    <span>Custom feature to add language codes.</span>
                </div>
                <div className="white-bg"> 
                  <div className="flex flex-center justify-end">
                      <div className="flex two-col border-right">
                        <button type="button" className="blue-btn active" id='add-btn-id' onClick={showIntendentModel}>Add</button>
                      </div>
                    </div>
                    <div className="table-responsive global-table">
                    <table className="sortable" aria-label="Language Custom Code Mapping">
                        <tr>
                          <th scope="col" className="link-color">Language</th>  
                          <th scope="col" className="link-color">OPAL-Marketing Code</th> 
                          <th scope="col" className="link-color">Custom Code</th> 
                          <th scope="col">Action</th>
                        </tr>
                        <tbody>
                              {languageForMapping.map((data,index)=>(
                              <tr key={index}>
                              <td>{data?.language?.display}</td>
                              <td>{data?.language?.code}</td>
                              <td>{data?.customCode}</td>
                                <td>
                                <button type="button" onClick={()=>removeDataLaguageCodeMaping(data)}  role="button" className="mr-15 inline-flex" aria-label="delete">
                                 <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M11.0599 2.33973C11.3056 2.58546 11.4573 2.90766 11.4917 3.25039H8.50673C8.54117 2.90766 8.69283 2.58546 8.93856 2.33973C9.21986 2.05843 9.60139 1.90039 9.99922 1.90039C10.397 1.90039 10.7786 2.05843 11.0599 2.33973ZM7.94861 1.34978C7.44021 1.85818 7.14008 2.5359 7.1031 3.25039H1.74922C1.56357 3.25039 1.38552 3.32414 1.25424 3.45542C1.12297 3.58669 1.04922 3.76474 1.04922 3.95039C1.04922 4.13604 1.12297 4.31409 1.25424 4.44537C1.38552 4.57664 1.56357 4.65039 1.74922 4.65039H2.77494L4.07301 15.896C4.17007 16.7369 4.57287 17.5127 5.20477 18.0759C5.83666 18.6391 6.65356 18.9503 7.50001 18.9504H12.4984C13.3449 18.9503 14.1618 18.6391 14.7937 18.0759C15.4256 17.5127 15.8284 16.7369 15.9254 15.896L17.2235 4.65039H18.2492C18.4349 4.65039 18.6129 4.57664 18.7442 4.44537C18.8755 4.31409 18.9492 4.13604 18.9492 3.95039C18.9492 3.76474 18.8755 3.58669 18.7442 3.45542C18.6129 3.32414 18.4349 3.25039 18.2492 3.25039H12.8953C12.8584 2.5359 12.5582 1.85818 12.0498 1.34978C11.506 0.805925 10.7683 0.500391 9.99922 0.500391C9.23009 0.500391 8.49246 0.805925 7.94861 1.34978ZM6.13615 17.0311C5.76064 16.6966 5.52118 16.2358 5.46333 15.7362C5.46333 15.7362 5.46333 15.7362 5.46332 15.7361L4.18462 4.65039H15.8138L14.5351 15.7361C14.4773 16.2357 14.2378 16.6966 13.8623 17.0311C13.4868 17.3657 13.0014 17.5505 12.4984 17.5504H7.50002C6.99708 17.5505 6.51168 17.3657 6.13615 17.0311ZM8.84419 7.30542C8.71292 7.17414 8.53487 7.10039 8.34922 7.10039C8.16357 7.10039 7.98552 7.17414 7.85424 7.30542C7.72297 7.43669 7.64922 7.61474 7.64922 7.80039V14.4004C7.64922 14.586 7.72297 14.7641 7.85424 14.8954C7.98552 15.0266 8.16357 15.1004 8.34922 15.1004C8.53487 15.1004 8.71292 15.0266 8.84419 14.8954C8.97547 14.7641 9.04922 14.586 9.04922 14.4004V7.80039C9.04922 7.61474 8.97547 7.43669 8.84419 7.30542ZM12.3492 7.80039C12.3492 7.61474 12.2755 7.43669 12.1442 7.30542C12.0129 7.17414 11.8349 7.10039 11.6492 7.10039C11.4636 7.10039 11.2855 7.17414 11.1542 7.30542C11.023 7.43669 10.9492 7.61474 10.9492 7.80039V14.4004C10.9492 14.586 11.023 14.7641 11.1542 14.8954C11.2855 15.0266 11.4636 15.1004 11.6492 15.1004C11.8349 15.1004 12.0129 15.0266 12.1442 14.8954C12.2755 14.7641 12.3492 14.586 12.3492 14.4004V7.80039Z" fill="#1D4ED8" stroke="#1D4ED8" strokeWidth="0.3"/>
                                 </svg>
                                </button>
                                <button type="button" onClick={()=>showModel(index)}  role="button" className="inline-flex" aria-label="edit">
                                   <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="17" height="19" viewBox="0 0 17 19" fill="none">
                                    <path d="M15.2521 4.97331C15.6144 4.61106 15.8137 4.12997 15.8137 3.61822C15.8137 3.10647 15.6144 2.62539 15.2521 2.26314L13.7322 0.743224C13.3699 0.380974 12.8889 0.181641 12.3771 0.181641C11.8654 0.181641 11.3843 0.380974 11.023 0.742266L0.833984 10.8996V15.1307H5.06311L15.2521 4.97331ZM12.3771 2.09831L13.898 3.61727L12.3742 5.13526L10.8543 3.61631L12.3771 2.09831ZM2.75065 13.214V11.6951L9.49732 4.96947L11.0172 6.48939L4.27153 13.214H2.75065ZM0.833984 17.0473H16.1673V18.964H0.833984V17.0473Z" fill="#1D4ED8"/>
                                    </svg>
                                </button>
                              </td>
                              </tr>
                            ))}
                      </tbody>
                      </table>
                    </div>
                </div>
             </div>
          </div>
        </section>
       </div>
     </form>
     {conintendent ? 
         <div className='lightbox-panel'>
         <div className="inner-lightbox-panel sm-lightbox-pannel pb-0 editLanguages">
         <div className="modal-header flex padd-lr">
         <strong>Edit Languages</strong>
         <button id="" className="close first-focus editModalClose" aria-label="close" onClick={hideModel} onKeyDown={(e)=>hideModalonKeydown(e)}>
             <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><path d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z" fill="white"></path><path d="M15.1267 15.1269C14.8925 15.3611 14.5169 15.3611 14.2827 15.1269L10.4998 11.3441L6.71699 15.1269C6.48278 15.3611 6.10715 15.3611 5.87293 15.1269C5.63871 14.8927 5.63871 14.517 5.87293 14.2828L9.65576 10.5L5.87293 6.71716C5.63871 6.48295 5.63871 6.10732 5.87293 5.8731C5.98783 5.7582 6.1425 5.69633 6.29275 5.69633C6.443 5.69633 6.59768 5.75378 6.71257 5.8731L10.4954 9.65593L14.2782 5.8731C14.3931 5.7582 14.5478 5.69633 14.6981 5.69633C14.8527 5.69633 15.003 5.75378 15.1179 5.8731C15.3521 6.10732 15.3521 6.48295 15.1179 6.71716L11.3439 10.5L15.1267 14.2828C15.3609 14.517 15.3609 14.8927 15.1267 15.1269Z" fill="white"></path></svg>
         </button>
         </div>
         <div className="lightbox-content padd-22">
           <div className="flex-center">
                           <input onChange={e=>setLanguageMapping({...languageMapping,customCode:e?.target?.value})} value={languageMapping?.customCode} placeholder="Language custom code " type="text" className="form-control-sm wd-100"  /> 
                           </div>
          {languageMapping?.customCode.length > 7?<span className="textDanger">Please enter a value of length 7 characters maximum.</span>:""}
          { Object.keys(errorCodeMsg).includes(languageMapping?.language?.code) ? <span className="textDanger">{errorCodeMsg[languageMapping?.language?.code]}</span> : "" }
         </div>	
         <div className="modal-footer modal-footer-border flex px-22">
             <button id="ccwCancel" className="btn btn-bold " onClick={hideIntendentModel} onKeyDown={(e)=>hideModalonKeydown(e)}>Cancel</button>
             <button id="ccwSaveBtn" onClick={(event)=>createCustomCode(event,"edit")} disabled={customValidationLength()}  className="btn btn-bold active">Save</button>
         </div>
         </div>		
     </div> :

            <div className='lightbox-panel'>
                <div className="inner-lightbox-panel sm-lightbox-pannel pb-0 addModal" aria-labelledby="add-modal"
                    aria-modal="true"
                    role="dialog">
                <div className="modal-header flex padd-lr">
                <strong id='add-modal'>Add Language Custom Code</strong>
                <button className="close first-focus addModalClose" aria-label="close" onClick={hideIntendentModel} >
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><path d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z" fill="white"></path><path d="M15.1267 15.1269C14.8925 15.3611 14.5169 15.3611 14.2827 15.1269L10.4998 11.3441L6.71699 15.1269C6.48278 15.3611 6.10715 15.3611 5.87293 15.1269C5.63871 14.8927 5.63871 14.517 5.87293 14.2828L9.65576 10.5L5.87293 6.71716C5.63871 6.48295 5.63871 6.10732 5.87293 5.8731C5.98783 5.7582 6.1425 5.69633 6.29275 5.69633C6.443 5.69633 6.59768 5.75378 6.71257 5.8731L10.4954 9.65593L14.2782 5.8731C14.3931 5.7582 14.5478 5.69633 14.6981 5.69633C14.8527 5.69633 15.003 5.75378 15.1179 5.8731C15.3521 6.10732 15.3521 6.48295 15.1179 6.71716L11.3439 10.5L15.1267 14.2828C15.3609 14.517 15.3609 14.8927 15.1267 15.1269Z" fill="white"></path></svg>
                </button>
                </div>
                <div className="lightbox-content padd-22">
                <div className="flex wrap-dropdown mar-bot10">
                    <div className="global-dropdown-block flex-center">
                    <label htmlFor="custom-lang-id">Select custom language tag</label>
                    <div className="global-dropdown-select">
                    <Select
                       classNamePrefix='cw'
                       menuShouldScrollIntoView={false}
                       closeMenuOnSelect={true} 
                       onChange={e=>setCustomLanguageTag(e)}
                       options={sortedLanguageForCodeMapping} 
                       aria-label="Select custom language tag"
                       id='custom-lang-id'
                       value={customCodeLanguage}
                      /> 
                    </div>
                    </div>
                  </div>
                  <label htmlFor="edit-custom-id">Language custom code </label>

                  <div className="flex-center">

                   <input onChange={e=>setLanguageMapping({...languageMapping,customCode:e?.target?.value})} value={languageMapping?.customCode}  type="text" className="form-control-sm wd-100" id='edit-custom-id' aria-label="Language custom code"/> 
                   </div>
                 {languageMapping?.customCode?.length > 7?<span className="textDanger">Please enter a value of length 7 characters maximum.</span>:""}
                 { Object.keys(errorCodeMsg).includes(languageMapping?.language?.code) ? <span className="textDanger">{errorCodeMsg[languageMapping?.language?.code]}</span> : "" }
               
                </div>	
                <div className="modal-footer modal-footer-border flex px-22">
                    <button id="ccw" className="btn btn-bold " onClick={hideIntendentModel}>Cancel</button>
                    <button id="ccwSave"  onClick={(event)=>createCustomCode(event,"add")} disabled={customValidationLength()}  className="btn btn-bold active">Save</button>
                </div>
                </div>		
            </div>

     }
     <div className={globalOverlay ? "gb-overlay show" : "gb-overlay hide"}>
      <div className="gb-loader">
          <RotatingLines
            strokeColor="#0096FF"
            strokeWidth="5"
            width="196"
            visible={true}
          />
        </div>
      </div> 
    </div>
  )
}
